import { t } from '@ankr.com/common';

import { Error as ErrorComponent } from './Error';
import { isChunkLoadError } from './isChunkLoadError';

export interface ErrorBoundaryProps {
  error: Error;
}

export const ErrorBoundary = ({ error }: ErrorBoundaryProps) => {
  // React Compiler must not auto-memoize this fallback: Sentry invokes it
  // imperatively from a class render() (no React dispatcher), so any
  // compiler-injected useMemo throws "Invalid hook call" (React #321).
  'use no memo';

  const isChunkError = isChunkLoadError(error);

  if (isChunkError) {
    return (
      <ErrorComponent
        title={t('error-boundary.chunk-load-error.title')}
        description={t('error-boundary.chunk-load-error.description')}
        buttonText={t('error-boundary.chunk-load-error.button')}
      />
    );
  }

  return (
    <ErrorComponent
      title={t('error-boundary.common.title')}
      description={t('error-boundary.common.description')}
      buttonText={t('error-boundary.common.button')}
    />
  );
};
